import React from 'react';
import Home from './pages/Home';
import Supporters from './components/Supporters';
import DigitalFarming from './components/DigitalFarming';
import Solutions from './components/Solutions';
import MobileSection from './components/MobileSmall';
import VoiceOfFarmers from './components/VoiceOfFarmers';
import CardSection from './components/CardSection';
import NewsLetter from './components/NewsLetter';

import { Modal } from 'react-modal';
import ReactDOM from 'react-dom';

function App() {
  return (
    <div className='font-inter'>
    <Home/>
    <NewsLetter/>
    {/* <Supporters/> */}
<div >
<DigitalFarming/>
</div>
    <Solutions/>
    <MobileSection/>
    <VoiceOfFarmers/>
    <CardSection/>
    </div>
  );
}

export default App;
